import {
  HEADER_LOGO,
  PAY_NOW,
  SHOW_BATCH_TABLE,
  HEADER_LOGO_IN_BASE,
  PAYALLVALUE,
  PAYALLNOWVALUE,
  HIDE_PAYMENT_BUTTON,
} from "../constants/index";
export const HeaderLogo = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: HEADER_LOGO, payload: payload });
  });
};

export const HeaderLogoInBase = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: HEADER_LOGO_IN_BASE, payload: payload });
  });
};

export const PayNow = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: PAY_NOW, payload: payload });
  });
};

export const showBatchBillingTable = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: SHOW_BATCH_TABLE, payload: payload });
  });
};

export const dispatchPayAllValue = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: PAYALLVALUE, payload: payload });
  });
};

export const dispacthPayNowRow = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: PAYALLNOWVALUE, payload: payload });
  });
};
export const HidePaymentInfoButton = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: HIDE_PAYMENT_BUTTON, payload: payload });
  });
};
